<template>
    <el-dialog title="操作" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false"              
               style="margin-top: -50px;" width="70%">
        <el-form size="small" :model="form">

            <div class="common-form">基本信息</div>
            <el-form-item label="ID" :label-width="formLabelWidth">
                <el-input v-model="form.model.product_id" autocomplete="off" readonly></el-input>
            </el-form-item>
            <el-form-item label="名称" :label-width="formLabelWidth">
                <el-input v-model="form.model.product_name" autocomplete="off" readonly></el-input>
            </el-form-item>
        
    
            <div class="common-form">基础操作</div>
            <el-form-item label="上下架"  :label-width="formLabelWidth">
                <el-radio-group  v-model="form.model.product_status" :disabled="form.model.audit_status==0">
                    <el-radio :label="10">上架</el-radio>
                    <el-radio :label="20">下架</el-radio>
                </el-radio-group>


                <!-- <el-form-item label="产品规格：" :rules="[{ required: true, message: '请选择产品规格' }]" >
                    <el-radio-group v-model="form.model.spec_type">
                        <el-radio :label="10">单规格</el-radio>
                        <el-radio v-if="Number(form.product_vars.single_spec) === 0" :label="20">多规格</el-radio>
                    </el-radio-group>
                    </el-form-item>

        
                    <template v-if="Number(form.model.spec_type) === 10">
                    <Single :type="type"></Single>
                    </template>

          
                    <template v-if="Number(form.model.spec_type) === 20">
                    <Many :type="type" :specData="form.specData"></Many>
                    </template> -->

            </el-form-item>








            
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
      import PorductApi  from '@/api/product.js';
      import Single from './spec/Single.vue';
      import Many from './spec/Many.vue';
    export default {
        components: {
            Single,
            Many,
    },
        data() {
            return {

                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,

                /*判断是编辑*/
                scene: 'edit',
                type:'edit',
                /*是否正在加载*/
                loading: true,
                /*是否正在提交保存*/
                save_loading: false,
                /*form表单数据*/
                form: {
                    supplySetting:{
                    is_supply:false,
                    },
                    // 时间对象
                    timer: '',
                    model: {
                    supply:'',
                    list: [],
                    attr_type: '',
                    product_plus_image:''
                    },

                    /*商品分类*/
                    catgory: [],
                    /*运费模板*/
                    delivery: [],
                    // 品牌
                    brand: [],
                    /*会员等级*/
                    gradeList: [],
                    product_del_ids: [],
                    tableData: [],
                    // 标签
                    labelList: [],
                    all_type: [],
                    product_label_del_ids: [],
                    /*规格数据*/
                    specData: null,
                    /*是否锁住*/
                    isSpecLocked: false,

                    commission_list: [],
                    supply_price_name: "成本价",
                    product_vars:{
                        single_spec:1,
                    }
                },
                /*模型数据*/
                model: {
                    supply_id:0,
                    /*商品名称*/
                    product_name: '',
                    product_days: '',
                    /*商品配送方式 */
                    delivery_type: [],
                    /*商品编码*/
                    product_no: '',
                    /*商品内部编码*/
                    product_diy_no: '',
                    /*商品分类- 平台*/
                    category_id: null,
                    /*商品分类- 商家/供应商*/
                    supply_category_id: null,

                    /*商品类型*/
                    type: 'product',
                    // 品牌
                    brand_id: null,
                    province_id: '',
                    city_id: '',
                    /*商品图片*/
                    image: [],
                    /*商品卖点*/
                    selling_point: '',
                    /*规格类别,默认10单规格，20多规格*/
                    spec_type: 10,
                    /*库存计算方式,默认20付款减库存，10下单减库存*/
                    deduct_stock_type: 20,
                    /*检查用户等级*/
                    is_alone_grade: 0,
                    /*单规格*/
                    sku: {
                    /*产品价格*/
                    product_price: 0,
                    /*产品供货价格*/
                    product_supply_price: 0,
                    // 最低渠道价
                    agent_min_price: 0,
                    // 最高渠道价
                    agent_max_price: 0,
                    /*产品划线价*/
                    line_price: 0,
                    /*库存数量*/
                    stock_num: 100,
                    /*商品重量*/
                    product_weight: '0',
                    warehouse_kw_id:0,
                    },
                    /*多规格类别*/
                    spec_many: {
                    /*多规格类别*/
                    spec_attr: [],
                    /*多规格表格数据*/
                    spec_list: []
                    },
                    /*商品详情内容*/
                    content: '',
                    /*运费模板ID*/
                    delivery_id: '',
                    /*商品状态*/
                    product_status: 10,
                    // 商品链接状态
                    link_status: 2,
                    // 链接显示开始时间
                    link_start_at: '',
                    // 链接显示结束时间
                    link_end_at: '',
                    /*初始销量*/
                    sales_initial: 0,
                    /*商品排序，默认100*/
                    product_sort: 100,
                    /*是否开启积分赠送,默认1为开启，0为关闭*/
                    is_points_gift: 1,
                    /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
                    is_points_discount: 1,
                    /*是否允许使用福利金抵扣,默认1为允许，0为不允许*/
                    is_open_welfare_discount:0,
                    /*福利金类型,默认1为固定数量，2为比例*/
                    is_welfare_discount_type:1,
                    /*福利金抵扣*/
                    is_welfare_discount:0,

                    /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
                    is_enable_grade: 1,
                    /*是否开启单独分销,默认0为关闭，1为开启*/
                    is_ind_agent: 0,
                    /*分销佣金类型,默认10为百分比，20为固定金额*/
                    agent_money_type: 10,
                    /*分销佣金类型,默认10为普通设置，20为详细设置*/
                    agent_type: 10,
                    /*一级佣金*/
                    first_money: null,
                    /*二级佣金*/
                    second_money: null,
                    /*三级佣金*/
                    third_money: null,
                    /* 按钮名称 */
                    mini_name: '',
                    /* 小程序id */
                    mini_appid: '',
                    /* 跳转页面 */
                    mini_page: '',
                    /* 商品直推佣金 */
                    direct_commission: 0,
                    /*是否虚拟商品*/
                    is_virtual: 0,
                    is_special_view: 0,
                    /*编码批次*/
                    code_product_open: 0,
                    /*开启云仓配送*/
                    open_storage: 0,
                    /*强制开启云仓配送*/
                    force_open_storage: 0,
                    // 平台链接
                    link: '',

                    // 备注
                    // remark:'',
                    // 是否上下架
                    automatic_shelves: 0,
                    // 上下架时间
                    shelves_time: [],
                    //预售时间
                    sale_time: '',
                    //发货时间
                    delivery_time: '',
                    setting: {
                    buy_auth: {
                        show_price_id: [],
                        buy_auth_id: [],
                        tips: '无权限',
                        name: '跳转连接',
                        linkUrl: '',
                        // 每月限购数量
                        monthLimit: '',
                    },
                    text: {
                        buy_text: '立即购买',
                    }
                    },
                    commission_type: [],
                    //限制购买
                    buy_limit: 0,
                    // 商品业绩
                    achievement: 0,
                    // 商品起购数
                    buy_num: 0,
                    video: '',
                    poster: '',
                    subtitle: '',
                    page_id:'',
                    grade_model: 0,
                    is_level_difference: 0,
                    lateral_ratio: 0,
                    unit_id:0,
                    warehouse_kw_id:0,
      
                }
            };
        },
        props: ['open_add','product_id'],
        created() {
            this.dialogVisible = this.open_add;
         
            this.getData();
        },
        provide: function () {
            return {
            form: this.form
            };
        },
        methods: {
             /**
     * 获取基础数据
     */
    getData: function () {
      let self = this;
      PorductApi.getEditData(
        {
          product_id: self.product_id,
          scene: self.scene
        },
        true
      )
        .then(res => {
          self.loading = false;
          /*单独产品折扣*/
          if (res.data.model.alone_grade_equity != null && typeof res.data.model.alone_grade_equity != 'undefined' && res.data.model.is_alone_grade == 1) {
            let equitys = res.data.model.alone_grade_equity;
            res.data.gradeList.forEach(item => {
              item.product_equity = equitys[item.grade_id];
            });
          }
          /*固定金额 */
          if (res.data.model.alone_grade_equity != null && typeof res.data.model.alone_grade_equity != 'undefined' && res.data.model.is_alone_grade == 2) {
            let equitys = res.data.model.alone_grade_equity;
            res.data.gradeList.forEach(item => {
              item.product_fixed = equitys[item.grade_id];
            });
          }

          /*详细独立分销佣金 */
          if (res.data.model.agent_money_type != null && typeof res.data.model.independent_commission != 'undefined' && res.data.model.agent_money_type == 30) {
            let independent_commission = res.data.model.independent_commission;
            res.data.gradeList.forEach(item => {

              if (independent_commission[item.grade_id]) {

                item.independent_commission = independent_commission[item.grade_id];

              }

            });
          }
        // 独立平级奖励设置
          if(res.data.model.lateral_ratio){
            let equitys =JSON.parse(res.data.model.lateral_ratio);
            console.log(res.data.model.lateral_ratio)
            res.data.gradeList.forEach(item => {
              console.log(equitys[item.grade_id])
              item.product_lateral_ratio = equitys[item.grade_id];
            });
          }


          res.data.relation_product.forEach(rp => {
            rp.product_image = rp.image[0]['file_path']
          })
          Object.assign(self.form, res.data);
          console.log(self.form.gradeList)
          self.form.gradeList = res.data.gradeList;
          self.form.timer = res.data.model.time;
          self.form.tableData = res.data.relation_product;
          self.form.labelList = res.data.relation_label
          self.form.product_del_ids = [];
          self.form.product_label_del_ids = [];
          self.form.storage_vars = res.data.storage_vars;
          console.log('res.data.product_vars',res.data.product_vars);
          self.form.product_vars = res.data.product_vars;
          if (!self.form.product_vars.product_no_text) {
            self.form.product_vars.product_no_text = '商品编码';
          }
          if (!self.form.product_vars.product_diy_no_text) {
            self.form.product_vars.product_diy_no_text = '商品自编码';
          }

          if (!res.data.model.setting) {
            self.form.model.setting = {
              buy_auth: {
                show_price_id: [],
                buy_auth_id: [],
                tips: '',
                name: '跳转连接',
                linkUrl: ''
              }
            };
          } 
          if (!self.form.supply) {
            self.form.no_supply = true
          } else {
            self.form.no_supply = self.form.supply.self_manage > 0;
            var supplySetting = self.form.supply.kmd_grade.setting
            supplySetting.is_supply = true;
            self.form.supplySetting = supplySetting
          }
          if(!self.form.model.supply){
            self.form.model.supply=''
          }

          if (!res.data.model.setting) {
            self.form.model.setting = {
              buy_auth: {
                show_price_id: [],
                buy_auth_id: [],
                tips: '',
                name: '跳转连接',
                linkUrl: ''
              }
            };
          }

          self.form.supply_price_name = self.form.no_supply ? '成本价' : '供货价';
          self.form.product_vars.product_no_text += "：";
          self.form.product_vars.product_diy_no_text += "：";
          if (res.data.specData) {
            self.$set(self.form.model, 'spec_many', res.data.specData);
          } else {
            self.$set(self.form.model, 'spec_many', {
              spec_attr: [],
              spec_list: []
            });
            if (res.data.model.sku[0]) {
              self.form.model.sku = res.data.model.sku[0];
            }
          }
          self.form.model.product_status = res.data.model.product_status.value;
          self.form.commission_list = res.data.commission_list;
          // self.form.model.checkedCities = res.data.model.deliveryType;
          self.form.all_type = res.data.all_type;
          self.form.model.attr_type = res.data.model.attr_type
          self.form.model.list = res.data.model.attr_list

          self.form.unit = res.data.unit;
          self.form.warehouse = res.data.warehouse;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list, type = 1) {
      let obj = {};
      if (type == 2) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_fixed;
        });
      } else if (type == 1) {
        list.forEach(item => {
          obj[item.grade_id] = item.product_equity;
        });
      } else if (type == 20) {
        list.forEach(item => {
          obj[item.grade_id] = item.independent_commission;
        });
      }else if(type == 30){
        list.forEach(item => {
          if(item.product_lateral_ratio){
            obj[item.grade_id] = item.product_lateral_ratio;
          }else{
            obj[item.grade_id] = 0;
          }

        });

      }

      return JSON.stringify(obj);
    },

    /*提交*/
    onSubmit: function () {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = formatModel(self.model, self.form.model);
          params.list = self.form.model.list
          params.scene = self.scene;
          params.image = self.ImgKeepId(params.image);
          params.product_id = self.product_id;
          params.relation_product = self.form.tableData;
          params.relation_label = self.form.labelList;
          params.alone_grade_equity = self.convertJson(self.form.gradeList, params.is_alone_grade);
          params.independent_commission = self.convertJson(self.form.gradeList, params.agent_type);
          params.lateral_ratio = self.convertJson(self.form.gradeList, 30);

          if (params.product_days == '') {
            params.product_days = 0;
          }
          if (params.product_days < 0) {
            self.$message({
              message: '商品有效期不可小于0',
              type: 'error'
            });
            return false;
          }
          if(self.form.model.spec_type == 20){
            var spec_list = self.form.specData.spec_list;
              var ind = 0;
              for(var i=0;i<spec_list.length;i++){
      
                if(spec_list[i].spec_form.warehouse_kw_id == '0' || !spec_list[i].spec_form.warehouse_kw_id){
                  ind++;
                }
              }
              if(ind > 0){
                self.$message({
                  message: '请选择库位',
                  type: 'error'
                });
                return false;
              }
          }
      
          self.save_loading = true;
          PorductApi.editProduct(params, true)
            .then(data => {
              self.save_loading = false;
              self.$message({
                message: '保存成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.save_loading = false;
            });
        }
      });
    },    
    
            editUser(){
                let self = this;
                self.loading = true;
                let params = self.form;
                ProductApi.op(params,true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            self.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            self.dialogFormVisible(true);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/plus/warehouse/index/dialog/Op.vue